module.exports = __webpack_public_path__ + "5e9624dfa7ecdab7d752a423bc88fa3e.svg";